import * as React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import ModalContainer from '@src/components/modal-container';
import Link from '@src/components/link';
import AppointmentSuccessModalStore from './store';

const styles = require('./index.less');

/**
 * 弹窗模板, 可以快速套用修改
 */
const AppointmentSuccessModal = ({ store, onClose }) => {
  // store.use();
  if (onClose) {
    store.onClose = onClose;
  }

  return (
    <ModalContainer modalState={store.isOpen}>
      <div className={cx(styles.modalWrap, store.type === 2 && styles.small)}>
        <Link className={styles.closeBtn} onClick={store.onClickClose} />
        <img src={require('./images/gift-success.png')} className={styles.successImg} alt="" />

        <div className={styles.qrcode}>
          <img src={store.type === 1 ? require('./images/send-title.png') : require('./images/send-title2.png')} className={styles.sendTitle} alt="" />
          {store.type === 1 && (
            <div className={styles.qrcodeImg}>
              <img src={require('./images/qrcode.png')} alt="" />
            </div>
          )}
        </div>

        <img src={require('./images/gift-other.png')} className={styles.giftOther} alt="" />
      </div>
    </ModalContainer>
  );
};

export default wrapStore(AppointmentSuccessModal, AppointmentSuccessModalStore);
